var path = '/app/dashboard/dashboard.transactions.html';
var html = "<div data-ng-controller=\"DashboardTransactionsCtrl\">\n  <wor-table\n    [(data)]=\"transactions\"\n    (query)=\"getTransactions($event.params)\"\n    [settings]=\"tableSettings\">\n  </wor-table>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;